module.exports = __webpack_public_path__ + "833754da7069f544d95f072ded23b86c.svg";